/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M10.7608 1.5492c2.5008-.2832 4.0823.6948 5.0705 1.9697C16.8541 4.8386 17.25 6.4975 17.25 7.4747v.5856l.5681.142c1.4729.3683 2.6422.8224 3.4416 1.513.7576.6544 1.2403 1.5712 1.2403 3.0358 0 1.3911-.6187 2.2863-1.4687 2.8625-.8833.5989-2.0387.8611-3.0313.8611a.75.75 0 0 0 0 1.5c1.2133 0 2.6829-.3126 3.8731-1.1195C23.0966 16.0257 24 14.684 24 12.7511c0-1.8593-.6423-3.2057-1.7597-4.171-.9486-.8194-2.1927-1.3222-3.5208-1.6914-.1235-1.2477-.6326-2.9081-1.7027-4.2887C15.7337.9445 13.6536-.288 10.5921.0587c-2.6312.298-4.3136 1.6974-5.3145 3.3599-.8306 1.3796-1.1907 2.932-1.2824 4.1913-.7385.1707-1.5608.5837-2.257 1.2079C.7746 9.6819 0 10.9968 0 12.751c0 1.7742.8951 3.0326 1.9642 3.8535 1.05.8062 2.2983 1.2206 3.1665 1.3606a.75.75 0 0 0 .2386-1.4809c-.6759-.109-1.6777-.4445-2.4916-1.0695C2.0828 14.8045 1.5 13.9506 1.5 12.7511c0-1.2721.549-2.1972 1.2397-2.8166.7183-.644 1.5392-.9136 1.9809-.9136h.75v-.75c0-1.1445.2829-2.7346 1.092-4.0786.7915-1.3146 2.087-2.404 4.1982-2.6431Z"
    />
    <path
      fill="currentColor"
      d="M7.6585 15.2556 12 10.9141l4.3425 4.3425a.75.75 0 0 1-.9578 1.1464l-.1038-.0867-2.5309-2.5309v8.7958a.75.75 0 0 1-1.4879.1334l-.0121-.1348v-8.7945l-2.5319 2.532a.7501.7501 0 0 1-.9558.0857l-.1038-.0867a.7502.7502 0 0 1-.0868-.9568l.0868-.1039Z"
    />
  </React.Fragment>,
  'Save'
);
